import { selectPartnerName } from '@/context/display';
import { useAppSelector } from '@/context/storeHooks';
import { useCopy } from '@/copy';
import { TRUCKSTOP_PARTNER_NAME } from '@/partners/truckstop';

export const testId = 'slogan';
export const truckstopTestId = 'truckstop-slogan';

export function Slogan(): JSX.Element | null {
    const partnerName = useAppSelector(selectPartnerName);
    const isTruckstop = partnerName === TRUCKSTOP_PARTNER_NAME;
    const { sloganLines } = useCopy().quickCalculator;

    if (isTruckstop) {
        return (
            <p
                data-testid={truckstopTestId}
                className='text font-bold uppercase text-center pt-2'
            >
                Conditional approval in {'<'} 2 mins
                <br />
                for free
            </p>
        );
    }

    // A partner can drop the slogan entirely. Six screens render this, so
    // anything that belongs to one screen does not live here.
    if (sloganLines.length === 0) return null;

    return (
        <p data-testid={testId} className='text font-bold text-sm'>
            {sloganLines.map((line, i) => (
                <span key={line}>
                    {i > 0 && <br />}
                    {line}
                </span>
            ))}
        </p>
    );
}
